<div class="p-3">
    <h1 mat-dialog-title>Payment Received</h1>
    <div mat-dialog-content [formGroup]="form">
        <div class="row my-3 mx-2">
            <div class="col d-flex flex-column mx-3">
                <div class="col d-flex flex-column sub-form-header-title" style="font-weight:bold;">
                    Claim ID:
                </div>
                <div class="col d-flex flex-column mt-2" style="margin-left:6px;">
                    {{ this.data.id }}
                </div>
            </div>
            <div class="col d-flex flex-column mx-3">
                <div class="col d-flex flex-column sub-form-header-title" style="font-weight:bold;">
                    Estimated Amount:
                </div>
                <div class="col d-flex flex-column mt-2" style="margin-left:6px;">
                    {{ formatCurrencyString(this.data.estimate_amount, this.currencySymbol) }}
                </div>
            </div>
        </div>
        <div class="row my-3 mx-2">
            <div class="col d-flex flex-column mx-3"></div>
            <div class="col d-flex flex-column mx-3">
                <div class="col d-flex flex-column sub-form-header-title" style="font-weight:bold;">
                    Amount Paid:
                </div>
                <div class="col d-flex flex-column mt-2" style="margin-left:6px;">
                    {{ formatCurrencyString(this.data.actual_amount, this.currencySymbol) }}
                </div>
            </div>
        </div>
        <div class="row p-3 mt-3">
            <div class="col d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Received Date<span class="required-input">*</span></mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="received_date" >
                    <mat-error *ngIf="!form.get('received_date')?.value">Required</mat-error>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Amount Paid ({{ this.currencySymbol }})<span class="required-input">*</span></mat-label>
                    <input type="number" step=".01" min="0" matInput placeholder="Enter Amount" formControlName="actual_amount">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" mat-dialog-close>
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" [disabled]="!canCreateClaimPayment()" (click)="submitClaimPayment()">
            <mat-icon>check</mat-icon>
            Submit Payment
        </button>
    </div>
</div>